module.exports = __webpack_public_path__ + "img/edit.2408a6f1.svg";